import {get} from 'lodash';
import {AbstractControl, NgForm} from '@angular/forms';
import {ChangeDetectorRef, Component, EventEmitter, Input, Optional, Output} from '@angular/core';

@Component({
    selector: '[click-to-edit]',
    template: require('./click.to.edit.template.html'),
    host: {
        "(click)": "trackEvent($event)"
    }
})
export class ClickToEdit {

    viewValue: any;
    editing: boolean = false;

    @Input('click-to-edit') public forName: string;
    @Input('cte-changes-highlight') useChangesHighlight: boolean = true;
    @Input('cte-disabled') disabled: boolean = false;
    @Input('use-custom-handler') useCustomHandler: boolean = false;
    @Output('on-change-value') onChangeValue: EventEmitter<any> = new EventEmitter<any>();

    private track;
    private previous: any;
    private changed: boolean = false;
    private callback: (any) => void;

    constructor(@Optional() private ngForm: NgForm,
                private changeDetectorRef: ChangeDetectorRef) {
    }

    ngOnInit() {
        this.initializeComponent()
    }

    ngOnChanges() {
        this.initializeComponent()
    }

    ngAfterViewInit() {
        this.initializeComponent()
    }

    initializeComponent() {
        this.viewValue = this.getCurrentValue();
        this.changeDetectorRef.detectChanges();
    }

    compareEvent(event) {
        if (this.track != event && this.editing) {
            this.cancel()
        }
    }

    trackEvent(event) {
        this.track = event;
    }

    changeApplied() {
        let value: any = this.getCurrentValue();

        this.changed = false;
        this.previous = value;
        this.viewValue = value;
    }

    changeExists() {
        return this.changed;
    }

    open() {
        if (!this.disabled) {
            this.editing = true;
            this.previous = this.getCurrentValue();
            this.subscribeGlobalClickHandler();
        }
    }

    save() {
        const control: AbstractControl = this.getControl();
        if (!!control && control.valid) {
            this.viewValue = this.getCurrentValue();
            this.changed = this.changed || this.viewValue !== this.previous;
            this.editing = false;

            if (this.useCustomHandler) {
                this.onChangeValue.emit(this.viewValue);
            }

            this.changeDetectorRef.detectChanges();
            this.unSubscribeGlobalClickHandler();
        }
    }

    cancel() {
        this.updateValue(this.previous);
        this.editing = false;
        this.unSubscribeGlobalClickHandler();
    }

    getCurrentValue() {
        return get(this.getControl(), 'value')
    }

    getValueClass() {
        return {
            'click-to-edit-value': true,
            'click-to-edit-disabled': this.disabled,
            'has-changes': this.useChangesHighlight && this.changed
        }
    }

    getInputClass() {
        return {
            'click-to-edit-input': true,
            'has-error': !get(this.getControl(), 'valid', true)
        }
    }

    private getControl(): AbstractControl {
        return <AbstractControl>this.ngForm.controls[this.forName]
    }

    private updateValue(value?: any) {
        const control: AbstractControl = this.getControl();
        if (control && control != null) {
            control.setValue(value)
        }
    }

    private subscribeGlobalClickHandler() {
        this.callback = this.compareEvent.bind(this);
        document.addEventListener('click', this.callback);
    }

    private unSubscribeGlobalClickHandler() {
        document.removeEventListener('click', this.callback);
        this.callback = undefined;
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/click-to-edit/click.to.edit.component.ts